import { RESET_DATA_PANEL } from './constants';

export default function factoryFilterBox(nameSpace = '') {
  const FETCH_QUERYCONDITIONS_INFO = `${nameSpace}_FETCH_QUERYCONDITIONS_INFO`;
  const RESET_FILTER_DATA = `${nameSpace}_RESET_FILTER_DATA`;

  function fetchQueryConditions(data) {
    return {
      type: `${nameSpace}_FETCH_QUERYCONDITIONS_INFO`,
      payload: data,
    };
  }

  function resetFilterBoxData() {
    return {
      type: `${nameSpace}_RESET_FILTER_DATA`,
    };
  }

  const initialState = {
    departments: [],
    // queryConditions: { activityCode: 'HDJH202008032046476950' }
    queryConditions: {},
  };

  // reducer 改变state 接收action和当前state作为参数，返回改变后的state
  function filterInfo(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case FETCH_QUERYCONDITIONS_INFO:
        return Object.assign({}, state, {
          queryConditions: payload,
        });
      case RESET_DATA_PANEL:
      case RESET_FILTER_DATA:
        return initialState;
      default:
        return state;
    }
  }

  return {
    fetchQueryConditions,
    resetFilterBoxData,
    filterInfo,
    FETCH_QUERYCONDITIONS_INFO,
  };
}
